import { useTopicPageData, useTopicSupporterVoicesData } from 'src/app/pages/topic/pageContext';
import type { TopicPageSupporterVoicesComment } from 'src/app/pages/topic/pageContext';

type Result = ModelHookResult<{
	shouldShowSupporterVoices: boolean;
	supporterVoices: readonly TopicPageSupporterVoicesComment[];
	topicName: string;
	totalSupporterVoices: number;
}>;

export function useSupporterVoices(): Result {
	const {
		data: { name },
	} = useTopicPageData();

	const {
		data: { comments, totalCount, hideSignees },
	} = useTopicSupporterVoicesData();

	return {
		data: {
			shouldShowSupporterVoices: comments.length >= 3 && !hideSignees,
			supporterVoices: comments,
			topicName: name,
			totalSupporterVoices: totalCount,
		},
	};
}
